var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebinarsinline = function SvgWebinarsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#webinars_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 12.5V15m0 0h4m-4 0H4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.582 2.91A2.327 2.327 0 0 1 2.909.581h10.182a2.327 2.327 0 0 1 2.327 2.327v7.273a2.33 2.33 0 0 1-2.327 2.327H2.91a2.327 2.327 0 0 1-2.327-2.327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.418a2.327 2.327 0 1 0 0-4.654 2.327 2.327 0 0 0 0 4.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2.5 10.5s.32-.392.935-.695S5.474 8.98 8 8.98s3.951.523 4.565.825c.614.303.935.695.935.695"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "webinars_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWebinarsinline;